"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Destroyer = require("../util/destroyer/Destroyer");
var _debounce = _interopRequireDefault(require("lodash/debounce"));
Entry.Workspace = /*#__PURE__*/function () {
  function Workspace(options) {
    (0, _classCallCheck2["default"])(this, Workspace);
    (0, _defineProperty2["default"])(this, "schema", {
      selectedBlockView: null,
      selectedBoard: null
    });
    (0, _defineProperty2["default"])(this, "isVimMode", this._isVimMode);
    Entry.Model(this, false);
    this._destroyer = this._destroyer || new _Destroyer.Destroyer();
    this._destroyer.destroy();
    this.scale = 1;
    this.dSetMode = (0, _debounce["default"])(this.setMode, 200);
    this.dReDraw = (0, _debounce["default"])(this.reDraw, 150);
    this.observe(this, '_handleChangeBoard', ['selectedBoard'], false);
    this.trashcan = new Entry.FieldTrashcan();
    this.zoomController = new Entry.ZoomController();
    this.readOnly = options.readOnly === undefined ? false : options.readOnly;
    this.blockViewMouseUpEvent = new Entry.Event(this);
    this.widgetUpdateEvent = new Entry.Event(this);
    this.reDrawEvent = new Entry.Event(this);
    this._blockViewMouseUpEvent = null;
    this.widgetUpdateEveryTime = false;
    this._hoverBlockView = null;
    var option = options.blockMenu;
    if (option) {
      this.blockMenu = new Entry.BlockMenu(option.dom, option.align, option.categoryData, option.scroll);
      this._destroyer.add(this.blockMenu);
      this.blockMenu.workspace = this;
      this.blockMenu.observe(this, '_setSelectedBlockView', ['selectedBlockView'], false);
    }
    option = options.board;
    if (option) {
      option.workspace = this;
      option.readOnly = this.readOnly;
      this.board = new Entry.Board(option);
      this.board.observe(this, '_setSelectedBlockView', ['selectedBlockView'], false);
      this.set({
        selectedBoard: this.board
      });
      if (this.blockMenu) {
        this.blockMenu.enableTrashcan();
      }
    }
    option = options.vimBoard;
    if (option) {
      this.vimBoard = new Entry.Vim(option.dom);
      this.vimBoard.workspace = this;
    }
    if (this.board && this.vimBoard) {
      this.vimBoard.hide();
    }
    Entry.GlobalSvg.createDom();
    this.mode = Entry.Workspace.MODE_BOARD;
    this.attachKeyboardCapture();

    // view state change event
    this.changeEvent = new Entry.Event(this);
    Entry.commander.setCurrentEditor('board', this.board);
    if (options.textType !== undefined) {
      this.textType = options.textType;
    } else {
      this.textType = Entry.Vim.TEXT_TYPE_PY;
    }
    this.oldMode = Entry.Workspace.MODE_BOARD;
    this.mode = Entry.Workspace.MODE_BOARD;
  }
  return (0, _createClass2["default"])(Workspace, [{
    key: "getBoard",
    value: function getBoard() {
      return this.board;
    }
  }, {
    key: "getSelectedBoard",
    value: function getSelectedBoard() {
      return this.selectedBoard;
    }
  }, {
    key: "getBlockMenu",
    value: function getBlockMenu() {
      return this.blockMenu;
    }
  }, {
    key: "getVimBoard",
    value: function getVimBoard() {
      return this.vimBoard;
    }
  }, {
    key: "getMode",
    value: function getMode() {
      return this.mode;
    }
  }, {
    key: "setMode",
    value: function setMode(mode, message, isForce) {
      var _this = this;
      if (Entry.options && !Entry.options.textCodingEnable && Entry.Workspace.MODE_VIMBOARD === mode.boardType) {
        return;
      }
      Entry.disposeEvent.notify();
      var playground = Entry.playground;
      if (!isForce && !checkObjectAndAlert(playground && playground.object)) {
        return false;
      } // change mode fail

      if (Entry.Utils.isNumber(mode)) {
        this.mode = mode;
      } else {
        this.mode = mode.boardType;
        this.runType = mode.runType;
        this.textType = mode.textType;
      }
      this.mode = Number(this.mode);
      if (this.oldMode === this.mode) {
        return;
      }
      Entry.variableContainer.updateList();
      var VIM = Entry.Vim;
      var WORKSPACE = Entry.Workspace;
      var blockMenu = this.blockMenu;
      var Util = Entry.TextCodingUtil;
      var dispatchChangeBoardEvent = function dispatchChangeBoardEvent() {
        _this.oldMode = _this.mode;
        Entry.isTextMode = _this.mode === WORKSPACE.MODE_VIMBOARD;
        blockMenu.align();
        Entry.dispatchEvent('workspaceChangeMode');
        _this.changeEvent.notify(message);
        Entry.dispatchEvent('cancelBlockMenuDynamic');
      };
      var changeToPythonMode = function changeToPythonMode() {
        try {
          _this.board && _this.board.hide();
          _this.overlayBoard && _this.overlayBoard.hide();
          _this.set({
            selectedBoard: _this.vimBoard
          });
          _this.vimBoard.show();
          blockMenu.banClass('functionInit', true);
          _this.codeToText(_this.board.code, mode);
          _this.oldTextType = _this.textType;
          _this.board.clear();
        } catch (e) {
          _this.vimBoard.hide();
          _this.board.show();
          blockMenu.unbanClass('functionInit');
          _this.set({
            selectedBoard: _this.board
          });
          _this.mode = WORKSPACE.MODE_BOARD;
          mode.boardType = WORKSPACE.MODE_BOARD;
          if (_this.oldTextType === VIM.TEXT_TYPE_JS) {
            mode.runType = VIM.MAZE_MODE;
          } else if (_this.oldTextType === VIM.TEXT_TYPE_PY) {
            mode.runType = VIM.WORKSPACE_MODE;
          }
          e.block && Entry.getMainWS() && Entry.getMainWS().board.activateBlock(e.block);
        } finally {
          _this.oldMode = 1;
          _this.mode = 1;
        }
      };
      switch (this.mode) {
        case WORKSPACE.MODE_VIMBOARD:
          {
            var alertMessage = Util.validateVariableAndListToPython() || Util.validateFunctionToPython() || Util.hasNotSupportedBlocks();
            var invalidEditorModeErrorMessage = Util.canConvertTextModeForOverlayMode(Entry.Workspace.MODE_VIMBOARD);
            if (invalidEditorModeErrorMessage) {
              Entry.modal.alert(invalidEditorModeErrorMessage);
              return;
            }
            if (alertMessage) {
              if (alertMessage.type === 'warning') {
                Entry.modal.confirm(alertMessage.message).then(function (result) {
                  if (result) {
                    var _Entry$expansion, _Entry$aiUtilize, _Entry$hwLite, _Entry$playground, _Entry$aiLearning;
                    Entry.variableContainer.removeNotPythonSupportedFunction();
                    (_Entry$expansion = Entry.expansion) === null || _Entry$expansion === void 0 || _Entry$expansion.banExpansionBlocks(Entry.expansionBlocks);
                    (_Entry$aiUtilize = Entry.aiUtilize) === null || _Entry$aiUtilize === void 0 || _Entry$aiUtilize.banAIUtilizeBlocks(Entry.aiUtilizeBlocks);
                    (_Entry$hwLite = Entry.hwLite) === null || _Entry$hwLite === void 0 || _Entry$hwLite.banClassAllHardwareLite();
                    (_Entry$playground = Entry.playground) === null || _Entry$playground === void 0 || (_Entry$playground = _Entry$playground.dataTable) === null || _Entry$playground === void 0 || _Entry$playground.removeAllBlocks();
                    (_Entry$aiLearning = Entry.aiLearning) === null || _Entry$aiLearning === void 0 || _Entry$aiLearning.removeAllBlocks();
                    Util.removeNotSupportedBlock();
                    Entry.playground.blockMenu.banClass('python_disable');
                    // 블럭 삭제되고 처리
                    requestAnimationFrame(function () {
                      changeToPythonMode();
                      dispatchChangeBoardEvent();
                    });
                  } else {
                    var _mode = {};
                    _mode.boardType = WORKSPACE.MODE_BOARD;
                    _mode.textType = -1;
                    Entry.getMainWS().setMode(_mode);
                    dispatchChangeBoardEvent();
                  }
                });
              } else if (alertMessage.type === 'error') {
                Entry.modal.alert(alertMessage.message);
                var _mode2 = {};
                _mode2.boardType = WORKSPACE.MODE_BOARD;
                _mode2.textType = -1;
                Entry.getMainWS().setMode(_mode2);
                dispatchChangeBoardEvent();
                break;
              }
            } else {
              changeToPythonMode();
              dispatchChangeBoardEvent();
            }
            break;
          }
        case WORKSPACE.MODE_BOARD:
          try {
            this.board.show();
            blockMenu.unbanClass('functionInit', true);
            Entry.playground.blockMenu.unbanClass('python_disable');
            this.set({
              selectedBoard: this.board
            });
            this.textToCode(this.oldMode, this.oldTextType);
            if (this.overlayBoard) {
              this.overlayBoard.hide();
            }
            this.oldTextType = this.textType;
            this.vimBoard && this.vimBoard.hide();
          } catch (e) {
            if (this.board && this.board.code) {
              this.board.code.clear();
            }
            if (this.board) {
              this.board.hide();
            }
            this.set({
              selectedBoard: this.vimBoard
            });
            blockMenu.banClass('functionInit');
            this.mode = WORKSPACE.MODE_VIMBOARD;
            if (this.oldTextType === VIM.TEXT_TYPE_JS) {
              this.boardType = WORKSPACE.MODE_VIMBOARD;
              this.textType = VIM.TEXT_TYPE_JS;
              this.runType = VIM.MAZE_MODE;
            } else if (this.oldTextType === VIM.TEXT_TYPE_PY) {
              this.boardType = WORKSPACE.MODE_VIMBOARD;
              this.textType = VIM.TEXT_TYPE_PY;
              this.runType = VIM.WORKSPACE_MODE;
            }
          }
          Entry.commander.setCurrentEditor('board', this.board);
          dispatchChangeBoardEvent();
          break;
        case WORKSPACE.MODE_OVERLAYBOARD:
          if (this.oldMode === WORKSPACE.MODE_VIMBOARD) {
            this.overlayModefrom = WORKSPACE.MODE_VIMBOARD;
          } else if (this.oldMode === WORKSPACE.MODE_BOARD) {
            this.overlayModefrom = WORKSPACE.MODE_BOARD;
          }
          if (!this.overlayBoard) {
            this.initOverlayBoard();
          }
          this.overlayBoard.show();
          this.set({
            selectedBoard: this.overlayBoard
          });
          Entry.commander.setCurrentEditor('board', this.overlayBoard);
          dispatchChangeBoardEvent();
          break;
      }
      function checkObjectAndAlert(object, message) {
        if (Entry.type === 'workspace' && !object) {
          Entry.modal.alert(message || Lang.Workspace.object_not_exist_error);
          return false;
        }
        return true;
      }
    }
  }, {
    key: "changeBoardCode",
    value: function changeBoardCode(code, cb) {
      this._syncTextCode();
      var isVim = this.mode === Entry.Workspace.MODE_VIMBOARD;
      this.board.changeCode(code, isVim, cb);
      if (isVim) {
        var mode = {};
        mode.textType = this.textType;
        mode.boardType = this.boardType;
        mode.runType = this.runType;
        this.codeToText(this.board.code, mode);
      }
    }
  }, {
    key: "changeOverlayBoardCode",
    value: function changeOverlayBoardCode(code) {
      if (this.overlayBoard) {
        this.overlayBoard.changeCode(code);
      }
    }
  }, {
    key: "changeBlockMenuCode",
    value: function changeBlockMenuCode(code) {
      this.blockMenu.changeCode(code);
    }
  }, {
    key: "textToCode",
    value: function textToCode(mode, oldTextType) {
      var _this2 = this;
      if (!this.vimBoard || mode !== Entry.Workspace.MODE_VIMBOARD) {
        return;
      }
      var changedCode = this.vimBoard.textToCode(oldTextType);
      var board = this.board;
      var code = board.code;
      if (!code) {
        return;
      }
      code.load(changedCode);
      this.changeBoardCode(code);
      setTimeout(function () {
        if (code.view) {
          code.view.reDraw();
          _this2.board.alignThreads();
        }
      }, 0);
    }
  }, {
    key: "codeToText",
    value: function codeToText(code, mode) {
      if (!this.vimBoard) {
        return;
      }
      code = code || this.board.code;
      mode = mode || {
        textType: this.textType,
        boardType: this.boardType,
        runType: this.runType
      };
      return this.vimBoard.codeToText(code, mode);
    }
  }, {
    key: "getCodeToText",
    value: function getCodeToText(code) {
      if (!this.vimBoard) {
        return;
      }
      return this.vimBoard.getCodeToText(code);
    }
  }, {
    key: "_setSelectedBlockView",
    value: function _setSelectedBlockView() {
      var _this3 = this;
      var view = 'selectedBlockView';
      var blockView = this.board[view] || this.blockMenu[view] || (this.overlayBoard ? this.overlayBoard[view] : null);
      this._unbindBlockViewMouseUpEvent();
      this.set({
        selectedBlockView: blockView
      });
      if (!blockView) {
        return;
      }
      this.setHoverBlockView();
      this._blockViewMouseUpEvent = blockView.mouseUpEvent.attach(this, function () {
        _this3.blockViewMouseUpEvent.notify(blockView);
      });
    }
  }, {
    key: "initOverlayBoard",
    value: function initOverlayBoard() {
      this.overlayBoard = new Entry.Board({
        dom: this.board.view,
        workspace: this,
        isOverlay: true,
        scale: this.scale
      });
      this.overlayBoard.changeCode(new Entry.Code([]));
      this.overlayBoard.workspace = this;
      this.overlayBoard.observe(this, '_setSelectedBlockView', ['selectedBlockView'], false);
    }
  }, {
    key: "_keyboardControl",
    value: function _keyboardControl(e, isForce) {
      if (Entry.Loader && !Entry.Loader.isLoaded()) {
        return;
      }
      var keyCode = e.keyCode || e.which;
      var ctrlKey = e.ctrlKey;
      var shiftKey = e.shiftKey;
      var altKey = e.altKey;
      var playground = Entry.playground;
      var object = playground && playground.object ? playground.object : undefined;
      if (Entry.Utils.isInInput(e) && !isForce) {
        return;
      }
      var isVimMode = this._isVimMode();
      var blockView = this.selectedBlockView;
      var board = this.selectedBoard;
      var isBoardReadOnly = board.readOnly;
      var checkKeyCodes;
      if (ctrlKey) {
        checkKeyCodes = [219, 221];
        if (checkKeyCodes.indexOf(keyCode) > -1) {
          if (!checkObjectAndAlert(object)) {
            return;
          }
        }
        var mainWorksapceMode = Entry.playground.mainWorkspace.getMode();
        var playgroundMode = Entry.playground.getViewMode();
        var isBlockCodeView = (mainWorksapceMode === Entry.Workspace.MODE_OVERLAYBOARD || mainWorksapceMode === Entry.Workspace.MODE_BOARD) && (playgroundMode === 'code' || playgroundMode === 'variable');
        switch (keyCode) {
          case 86:
            //paste
            if (!isBoardReadOnly && board && board instanceof Entry.Board && Entry.clipboard && isBlockCodeView) {
              Entry["do"]('addThread', Entry.clipboard).value.getFirstBlock().copyToClipboard();
            }
            break;
          case 219:
            {
              //setMode(block) for textcoding ( ctrl + [ )
              if (!Entry.options.textCodingEnable || Entry.playground.getViewMode() === 'picture') {
                return;
              }
              var oldMode = Entry.getMainWS().oldMode;
              if (oldMode === Entry.Workspace.MODE_OVERLAYBOARD) {
                return;
              }
              this.dSetMode({
                boardType: Entry.Workspace.MODE_BOARD,
                textType: -1
              });
              e.preventDefault();
              break;
            }
          case 221:
            {
              //setMode(python) for textcoding ( ctrl + ] )
              if (!Entry.options.textCodingEnable || Entry.playground.getViewMode() === 'picture') {
                return;
              }
              var message = Entry.TextCodingUtil.canConvertTextModeForOverlayMode(Entry.Workspace.MODE_VIMBOARD);
              if (message) {
                Entry.modal.alert(message);
                return;
              }
              this.dSetMode({
                boardType: Entry.Workspace.MODE_VIMBOARD,
                textType: Entry.Vim.TEXT_TYPE_PY,
                runType: Entry.Vim.WORKSPACE_MODE
              });
              e.preventDefault();
              break;
            }
          case 67:
            if (blockView && !blockView.isInBlockMenu && blockView.block.isDeletable() && blockView.block.isCopyable()) {
              blockView.block.copyToClipboard();
            }
            break;
          case 88:
            if (!isBoardReadOnly && blockView && !blockView.isInBlockMenu && blockView.block.isDeletable()) {
              (function (block) {
                block.copyToClipboard();
                Entry["do"]('destroyBlockBelow', block);
                blockView.getBoard().setSelectedBlock(null);
              })(blockView.block);
            }
            break;
        }
      } else if (altKey) {
        checkKeyCodes = [49, 50, 51, 52, 219, 221];
        if (checkKeyCodes.indexOf(keyCode) > -1) {
          if (!checkObjectAndAlert(object)) {
            return;
          }
        }
        switch (keyCode) {
          case 49:
            playground.changeViewMode('code');
            e.preventDefault();
            break;
          case 50:
            playground.changeViewMode('picture');
            e.preventDefault();
            break;
          case 51:
            playground.changeViewMode('sound');
            e.preventDefault();
            break;
          case 52:
            playground.toggleOnVariableView();
            playground.changeViewMode('variable');
            e.preventDefault();
            break;
          case 219:
            if (Entry.container) {
              e.preventDefault();
              Entry.container.selectNeighborObject('prev');
            }
            break;
          case 221:
            if (Entry.container) {
              e.preventDefault();
              Entry.container.selectNeighborObject('next');
            }
            break;
        }
      } else if (shiftKey) {
        switch (keyCode) {
          case 9:
            if (isVimMode) {
              CodeMirror.commands.indentLess(this.vimBoard.codeMirror);
              e.preventDefault();
            }
            break;
        }
      } else {
        switch (keyCode) {
          case 9:
            if (isVimMode) {
              CodeMirror.commands.indentMore(this.vimBoard.codeMirror);
              e.preventDefault();
            }
            break;
          case 8:
          case 46:
            if (!isBoardReadOnly && blockView && !blockView.isInBlockMenu && blockView.block.isDeletable() && !blockView.isFieldEditing()) {
              if (Entry.engine.isState('stop')) {
                Entry["do"]('destroyBlock', blockView.block);
                this.board.set({
                  selectedBlockView: null
                });
                e.preventDefault();
              }
            }
            break;
        }
      }

      //delay for fields value applied
      setTimeout(function () {
        Entry.disposeEvent && Entry.disposeEvent.notify(e);
      }, 0);
      function checkObjectAndAlert(object, message) {
        if (!object) {
          message = message || Lang.Workspace.object_not_exist_error;
          Entry.modal.alert(message);
          return false;
        }
        return true;
      }
    }
  }, {
    key: "_handleChangeBoard",
    value: function _handleChangeBoard() {
      var board = this.selectedBoard;
      if (!board) {
        return;
      }
      if (board.constructor === Entry.Board) {
        this.zoomController.setBoard(board);
        this.trashcan.setBoard(board);
      }
    }
  }, {
    key: "_syncTextCode",
    value: function _syncTextCode() {
      if (this.mode !== Entry.Workspace.MODE_VIMBOARD || Entry.engine && Entry.engine.isState('run')) {
        return;
      }
      var changedCode = this.vimBoard.textToCode(this.textType);
      var board = this.board;
      var code = board.code;
      if (code) {
        code.load(changedCode);
      }
      var event = Entry.creationChangedEvent;
      event && event.notify(true);
    }
  }, {
    key: "addVimBoard",
    value: function addVimBoard(dom) {
      if (this.vimBoard) {
        return;
      }
      this.vimBoard = new Entry.Vim(dom);
      this.vimBoard.workspace = this;
      this.vimBoard.hide();
    }
  }, {
    key: "getParserType",
    value: function getParserType() {
      return this.vimBoard._parserType;
    }
  }, {
    key: "getBlockViewRenderMode",
    value: function getBlockViewRenderMode() {
      switch (this.mode) {
        case Entry.Workspace.MODE_BOARD:
        case Entry.Workspace.MODE_OVERLAYBOARD:
          return Entry.BlockView.RENDER_MODE_BLOCK;
        case Entry.Workspace.MODE_VIMBOARD:
          return Entry.BlockView.RENDER_MODE_TEXT;
      }
    }
  }, {
    key: "_isVimMode",
    value: function _isVimMode() {
      return this.oldMode === Entry.Workspace.MODE_VIMBOARD;
    }
  }, {
    key: "attachKeyboardCapture",
    value: function attachKeyboardCapture() {
      if (Entry.keyPressed) {
        this._keyboardEvent && this.detachKeyboardCapture();
        this._keyboardEvent = Entry.keyPressed.attach(this, this._keyboardControl);
      }
    }
  }, {
    key: "detachKeyboardCapture",
    value: function detachKeyboardCapture() {
      if (Entry.keyPressed && this._keyboardEvent) {
        this._keyboardEvent.destroy();
        delete this._keyboardEvent;
      }
    }
  }, {
    key: "_unbindBlockViewMouseUpEvent",
    value: function _unbindBlockViewMouseUpEvent() {
      if (this._blockViewMouseUpEvent) {
        this._blockViewMouseUpEvent.destroy();
        this._blockViewMouseUpEvent = null;
      }
    }
  }, {
    key: "setWidgetUpdateEveryTime",
    value: function setWidgetUpdateEveryTime(val) {
      this.widgetUpdateEveryTime = !!val;
    }
  }, {
    key: "syncCode",
    value: function syncCode() {
      switch (this.mode) {
        case Entry.Workspace.MODE_VIMBOARD:
          this._syncTextCode();
          break;
      }
    }
  }, {
    key: "setHoverBlockView",
    value: function setHoverBlockView(blockView) {
      var oldBlockView = this._hoverBlockView;
      oldBlockView && oldBlockView.resetBackgroundPath();
      this._hoverBlockView = blockView;
      blockView && blockView.setBackgroundPath();
    }
  }, {
    key: "reDraw",
    value: function reDraw() {
      var blockMenu = this.blockMenu;
      var board = this.board;
      var overlayBoard = this.overlayBoard;
      blockMenu && blockMenu.reDraw();
      board && board.reDraw();
      overlayBoard && overlayBoard.reDraw();
      if (blockMenu || board || overlayBoard) {
        this.reDrawEvent.notify();
      }
    }
  }, {
    key: "getCurrentBoard",
    value: function getCurrentBoard() {
      var _Entry$Workspace = Entry.Workspace,
        MODE_BOARD = _Entry$Workspace.MODE_BOARD,
        MODE_VIMBOARD = _Entry$Workspace.MODE_VIMBOARD,
        MODE_OVERLAYBOARD = _Entry$Workspace.MODE_OVERLAYBOARD;
      switch (this.mode) {
        case MODE_BOARD:
          return this.getBoard();
        case MODE_VIMBOARD:
          return this.getVimBoard();
        case MODE_OVERLAYBOARD:
          return this.overlayBoard;
      }
    }
  }, {
    key: "setScale",
    value: function setScale() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.scale = scale;
      this.board.setScale(scale);
      Entry.GlobalSvg.setScale(scale);
      if (this.overlayBoard) {
        this.overlayBoard.setScale(scale);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyer.destroy();
    }
  }]);
}();
Entry.Workspace.MODE_BOARD = 0;
Entry.Workspace.MODE_VIMBOARD = 1;
Entry.Workspace.MODE_OVERLAYBOARD = 2;